import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { Avatar, Box } from '@mui/material';
import { GridColDef } from "@mui/x-data-grid";
import { CustomActionsCell, DefaultCheckBox } from 'src/components';
import { CustomActionsCellTypes } from "src/components/CustomActionsCell/CustomActionsCell.types";
import { CustomNameCellProps } from 'src/components/CustomNameCell/CustomNameCell.types';
import { priceNormalizer } from 'src/utils/helpers';
import { PriceActionTypes } from 'src/utils/helpers/helpers.types';

export const CustomNameCell = ({ params }: any) => {
  return (
    <Box display="flex" alignItems="center">
      {
        params.row?.onCheckBoxClick ? (
          <DefaultCheckBox
            isChecked={params.row.isChecked}
            onChange={params.row.onCheckBoxClick}
            sx={{
              marginLeft: '4px',
              marginRight: '8px',
              backgroundColor: '#fff'
            }}
          />
        ) : null
      }
      <Avatar
        variant="rounded"
        src={params.row.image}
        sx={{
          width: 40,
          height: 40,
          marginRight: '8px',
          borderRadius: '4px',
        }}
      >
        <PersonIcon
          sx={{
            fontSize: "25px",
          }}
        />
      </Avatar>
      {params.value}
    </Box>
  );
};

const priceValueGetter = (price: any) => {
  const normalizedPrice = priceNormalizer(price, PriceActionTypes.Showing);
  return `€ ${normalizedPrice.toFixed(2)}`;
}

export const columns: GridColDef[] = [
  {
    field: "title",
    headerName: "Name",
    width: 340,
    sortable: false,
    renderCell: (params) => <CustomNameCell params={params} />,
  },
  {
    field: "id",
    headerName: "ID",
    width: 150,
    sortable: false,
  },
  {
    field: "duration",
    headerName: "Duration",
    minWidth: 120,
    sortable: false,
    valueGetter: (params) => {
      return `${Math.floor(params.row.duration / 60)}h ${Math.floor(
        params.row.duration - Math.floor(params.row.duration / 60) * 60
      )}min`;
    },
  },
  {
    field: "norank",
    headerName: "No rank",
    width: 120,
    sortable: false,
    valueGetter: (params) => priceValueGetter(params?.row?.priceList?.[0]?.price),
  },
  {
    field: "junior",
    headerName: "Junior",
    width: 120,
    sortable: false,
    valueGetter: (params) => priceValueGetter(params?.row?.priceList?.[1]?.price),
  },
  {
    field: "master",
    headerName: "Master",
    width: 120,
    sortable: false,
    valueGetter: (params) => priceValueGetter(params?.row?.priceList?.[2]?.price),
  },
  {
    field: "top",
    headerName: "Top",
    width: 120,
    sortable: false,
    valueGetter: (params) => priceValueGetter(params?.row?.priceList?.[3]?.price),
  },
  {
    field: "actions",
    headerName: "Actions",
    minWidth: 140,
    sortable: false,
    renderCell: (params) => <CustomActionsCell params={params} type={CustomActionsCellTypes.SERVICES} />,
  },
];
